<script>
    export let message
    export let config
    export let room

    import API from "../API";

    async function validate(){
        const { data } = await API.post('/groupchat/api/updateMessageModerationStatus.php', {
            idMessage: message.idMessage,
            moderationStatus: 'valid'
        })

        message.moderationStatus = 'valid'
    }

    async function censor(){
        const { data } = await API.post('/groupchat/api/updateMessageModerationStatus.php', {
            idMessage: message.idMessage,
            moderationStatus: 'censored'
        })

        message.moderationStatus = 'censored'
    }
</script>


    <div class:admin="{message.fromAdmin == 1}" class:valid={message.moderationStatus == 'valid' && message.fromAdmin == 0} class:censored={message.moderationStatus == 'censored' && message.fromAdmin == 0} class:adminHidden={message.moderationStatus == 'censored' && message.fromAdmin == 1} class="message">
        {#if message.fromAdmin == 1}
            <div class="controls">
                {#if config.hasMessageControls}
                    {#if message.moderationStatus != 'valid'}
                        <span on:click={validate} class="material-icons">done</span>
                    {/if}
                    {#if message.moderationStatus != 'censored'}
                        <span on:click={censor} class="material-icons">close</span>
                    {/if}
                    {#if room.messagesCanBeEdited == 1}
                        <span class="sep"></span>
                        <span class="material-icons">edit</span>
                    {/if}
                {/if}
            </div>
        {/if}
        <div  class="message-infos">
            <div class="message-content">
                <p>{message.message}</p>
            </div>
            {#if room.hasLikes == 1}
                <p class="likes">{message.likes.length} <span class="material-icons">favorite</span></p>
            {/if}
            {#if message.fromAdmin == 1}
                <p class="username">Event organisation team</p>
            {:else}
                <p class="username">{message.first_name} {message.name} - {message.email}</p>
            {/if}
        </div>
        {#if message.fromAdmin == 0 && config.hasMessageControls}
            <div class="controls">
                {#if config.hasMessageControls}
                    {#if message.moderationStatus != 'valid'}
                        <span on:click={validate} class="material-icons">done</span>
                    {/if}
                    {#if message.moderationStatus != 'censored'}
                        <span on:click={censor} class="material-icons">close</span>
                    {/if}
                    {#if room.messagesCanBeEdited == 1}
                        <span class="sep"></span>
                        <span class="material-icons">edit</span>
                    {/if}
                    {#if room.hasCast == 1 || room.hasFeed == 1 || room.hasTablet == 1}
                        <span class="sep"></span>
                    {/if}
                    {#if room.hasCast == 1}
                        <span class="material-icons">cast</span>
                    {/if}
                    {#if room.hasFeed == 1}
                        <span class="material-icons">playlist_add</span>
                    {/if}
                    {#if room.hasTablet == 1}
                        <span class="material-icons">tablet_mac</span>
                    {/if}
                {/if}
            </div>
        {/if}

    </div>
<style>

    .sep {
        width: 10px;
    }

    .controls {
        display: flex;
        align-items: center;
    }

    .controls span {
        display: block;
        cursor: pointer;
        margin: 0 5px;
    }

    .message {
        padding: 15px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: solid 1px #D0D0D0;
    }

    .message-content {
        padding: 10px 15px;
        border-radius: 7px;
        width: fit-content;
        margin-bottom: 5px;
        border: solid 1px #707070;
        color: #707070;
    }

    .admin .message-content {
        background-color: #707070;
        color: white;
    }

    .valid .message-content {
        border: solid 1px #4bcc58;
        background-color: #4bcc58;
        color: white;
    }

    .censored .message-content {
        border: solid 1px #cc4b4b;
        background-color: #cc4b4b;
        color: white;
    }

    .adminHidden .message-content {
        border: solid 1px #cccccc;
        background-color: #cccccc;
        color: #707070;
    }

    .admin {
        margin-left: auto;
    }

    .username {
        font-size: 12px;
        font-weight: 200;
    }

    .likes {
        font-size: 12px;
        font-weight: 200;
        margin-bottom: 5px;
        display: flex;
        align-items: center;
    }

    .likes span {
        font-size: 12px;
        margin-left: 3px;
        color: #707070;
    }
</style>